// import { isRunningInElectron } from '@/utils/electronUtils'

import {
  articleDialogueModeTypeMap,
  articlePassageModeTypeMap,
  sentenceModeTypeMap,
  wordModeTypeMap
} from '@/utils/dictionary'

const UUID = require('uuid')
import { DefaultStudent } from '@/utils/mockData.js'
import md5 from 'js-md5'
import _ from 'lodash'
import store from '@/store'
import service from '@/utils/service'

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

// 设置 uuid
export function generatorUUID() {
  return getGeneratorUUID()
}

// 生成 uuid
function getGeneratorUUID() {
  return _.replace(UUID.v4(), /-/g, '') + md5(store.getters.userId + `${+new Date()}`).substring(0, 6)
}

const UUIDKey = 'aiclassroom-UUID-key'

export function getUUID() {
  return localStorage.getItem(UUIDKey)
}

export function setUUID(uuid) {
  localStorage.setItem(UUIDKey, uuid)
}

export function removeUUID() {
  localStorage.removeItem(UUIDKey)
}

// 生成uuid
export const generateUUID = len => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  const radix = chars.length
  if (len) {
    for (let i = 0; i < len; i += 1) uuid[i] = chars[0 | (Math.random() * radix)]
  } else {
    // rfc4122, version 4 form
    let r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (let i = 0; i < 36; i += 1) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

/**
 *  列表转树形 支持任意参数
 * @param flatList
 * @param idFieldName
 * @param parentKeyFieldName
 * @param fieldNameForChildren
 * @return {*[]}
 */
export function buildTree(flatList, idFieldName, parentKeyFieldName, fieldNameForChildren) {
  const rootElements = []
  const lookup = {}
  flatList.forEach(function (flatItem) {
    const itemId = flatItem[idFieldName]
    lookup[itemId] = flatItem
    flatItem[fieldNameForChildren] = []
  })
  flatList.forEach(function (flatItem) {
    const parentKey = flatItem[parentKeyFieldName]
    if (parentKey != null) {
      const parentObject = lookup[flatItem[parentKeyFieldName]]
      if (parentObject) {
        parentObject[fieldNameForChildren].push(flatItem)
      } else {
        rootElements.push(flatItem)
      }
    } else {
      rootElements.push(flatItem)
    }
  })
  return rootElements
}

export function map2list(map) {
  const list = []
  for (const key in map) {
    list.push({
      label: map[key],
      value: key
    })
  }
  return list
}
/**
 * 格式化时间
 * @Param Number duration 时长
 * @return String 00:00 格式
 **/
export const formatDuration = duration => {
  if (typeof duration === 'number') {
    return [parseInt(((duration / 60) % 60).toString()), parseInt((duration % 60).toString())]
      .join(':')
      .replace(/\b(\d)\b/g, '0$1')
  }
}
// 判断是否JSON格式
export const isJSON = str => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      return !!(typeof obj === 'object' && obj)
    } catch (e) {
      return false
    }
  } else {
    return false
  }
}
/**
 * 验证密码格式
 * @param val 密码文本
 * @returns {boolean} true: 格式正确；false: 格式错误
 */
export const validatePassword = val => {
  const reg = /^\S*(?=\S{8,25})(?=\S*\d)(?=\S*[a-z])(?=\S*[\W._])\S*$/
  return reg.test(val)
}
/**
 * 设置音标
 * @param {*} text 需处理的音标文本
 */
export const formatSoundmark = function (text) {
  // 处理中括号 '['、 ']'
  text = text.replace(/\[/g, '')
  text = text.replace(/]/g, '')
  text = text.split(';').join(',')
  return text
}

/**
 * 单词词性合集
 */
export const wordPartsOfSpeech = [
  {
    name: 'n.'
  },
  {
    name: 'v.'
  },
  {
    name: 'vt.'
  },
  {
    name: 'vi.'
  },
  {
    name: 'adj.'
  },
  {
    name: 'adv.'
  },
  {
    name: 'prep.'
  },
  {
    name: 'pron.'
  },
  {
    name: 'conj.'
  },
  {
    name: 'art.'
  },
  {
    name: 'num.'
  },
  {
    name: 'pl.'
  },
  {
    name: 'modal v.'
  },
  {
    name: 'aux.v.'
  },
  {
    name: 'interj.'
  },
  {
    name: 'det.'
  },
  {
    name: 'abbr.'
  },
  {
    name: 'pt.'
  },
  {
    name: 'pp.'
  },
  {
    name: 'vt. & vi.'
  },
  {
    name: 'comb.'
  }
]

/**
 * 随机排序单词列表
 * @param {Array} 单词列表
 * */
export const randomSortWordList = list => {
  const temp = []
  for (let i = list.length; i > 0; i--) {
    const temRandom = Math.floor(Math.random() * i)
    temp.push(list[temRandom])
    list.splice(temRandom, 1) // 抽取一张后，要除去这张牌，然后在剩下的牌中继续抽
  }
  return temp
}

/**
 * 处理单词词性
 * @param pos 词性类型
 * @returns {string} 词性标识
 */
export const partsOfSpeech = pos => {
  let name
  switch (pos) {
    case '0':
      name = 'n.'
      break
    case '1':
      name = 'v.'
      break
    case '2':
      name = 'vt.'
      break
    case '3':
      name = 'vi.'
      break
    case '4':
      name = 'adj.'
      break
    case '5':
      name = 'adv.'
      break
    case '6':
      name = 'prep.'
      break
    case '7':
      name = 'pron.'
      break
    case '8':
      name = 'conj.'
      break
    case '9':
      name = 'art.'
      break
    case '10':
      name = 'num.'
      break
    case '11':
      name = 'pl.'
      break
    case '12':
      name = 'modal v.'
      break
    case '13':
      name = 'aux.v.'
      break
    case '14':
      name = 'interj.'
      break
    case '15':
      name = 'det.'
      break
    case '16':
      name = 'abbr.'
      break
    case '17':
      name = 'pt.'
      break
    case '18':
      name = 'pp.'
      break
    case '19':
      name = 'vt. & vi.'
      break
    case '20':
      name = 'comb.'
      break
    default:
      name = ''
  }
  return name
}

/**
 * 年级转换
 *
 */
export const gradeChange = val => {
  let newVal
  switch (Number(val)) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 7:
      newVal = 7
      break
    case 4:
    case 5:
    case 6:
    case 8:
    default:
      newVal = 8
      break
  }
  return newVal
}

// 随机名字
export const randomName = () => {
  const name = []
  const xing =
    '赵钱孙李周吴郑王冯陈褚卫蒋沈韩杨朱秦尤许何吕施张孔曹严华金魏陶姜戚谢邹喻柏水窦章云苏潘葛奚范彭郎鲁韦昌马苗凤花方俞任袁柳酆鲍史唐费廉岑薛雷贺倪汤滕殷罗毕郝邬安常乐于时傅皮卞齐康伍余元卜顾孟平黄和穆萧尹姚邵湛汪祁毛禹狄米贝明臧计伏成戴谈宋茅庞熊纪舒屈项祝董梁杜阮蓝闵席季麻强贾路娄危江童颜郭梅盛林刁钟徐邱骆高夏蔡田樊胡凌霍虞万支柯昝管卢莫经房裘缪干解应宗丁宣贲邓郁单杭洪包诸左石崔吉钮龚程嵇邢滑裴陆荣翁荀羊於惠甄曲家封芮羿储靳汲邴糜松井段富巫乌焦巴弓牧隗山谷车侯宓蓬全郗班仰秋仲伊宫宁仇栾暴甘钭厉戎祖武符刘景詹束龙叶幸司韶郜黎蓟薄印宿白怀蒲邰从鄂索咸籍赖卓蔺屠蒙池乔阴鬱胥能苍双闻莘党翟谭贡劳逄'.split(
      ''
    )
  const ming =
    '志尚风睿振荣嘉慕宏远子瑜英逸翔飞才鸿博专弘方雨天成空开霁文言光明巍奕斌致建安阳舒珠长智刚胜意高达景昂奇思新强峰瀚钰星俊豪承福君昆琦彬炳阔广鹏运彭彰泰清厉辉昌邈河辰平晋宁轩腾知益永贞格华良力夫康骞礼越涵火正昊硕钊木聪宇元忠稷范耀宜茂彦锦程翰学晖州雄海资曦拔和蕴勇男城同玉涛向宾白锐典航乾晨德义韵苑霖名魄曜洽淼寿仙旭温纶剑毅然经武谨乐水峻石栋泽玥杰崇波勋磊柏伟山东烨掣恺修竹晔中锋兴浩物畅汉诚雅健年鲲盛立震皓跃易鹤珧大纵涆容珹实池双颜浦旷春信瑞赐敬晓羽理群用壮澹树骏桀楚量云龙喆生欢材延洁捷苍琪民烁峯朝来湃育凯旋日雪祺嗣业遥煜炫骥宝弼略悟玮甫迈哲坚秉艺'.split(
      ''
    )
  const xingFlag = Math.ceil(Math.random() * xing.length)
  const mingFlag = Math.ceil(Math.random() * ming.length)
  name[0] = xing[xingFlag]
  name[1] = ming[mingFlag]
  if (xingFlag > mingFlag) {
    name[2] = ming[xingFlag - mingFlag]
  }
  return name.join('')
}

/**
 * 生成 [m, n) 区间的随机整数
 * @param m Number 类型 最小值（大于等于）
 * @param n Number 类型 最大值（小于）
 * @returns {number}
 * m要小于n
 */
export const randomNum = (m, n) => {
  return Math.floor((n - m) * Math.random() + m)
}

export const objSort = obj => {
  const arr = Object.entries(obj)

  function compare(index) {
    return (a, b) => {
      a = a[index]
      b = b[index]
      if (a < b) return -1
      if (a > b) return 1
      return 0
    }
  }

  arr.sort(compare(0))
  let str = ''
  for (let i = 0, len = arr.length; i < len; i += 1) {
    str += `${arr[i][0]}=${arr[i][1]}`
    if (i !== len - 1) {
      str += '&'
    }
  }
  return str
}

/**
 * 去评测文本
 * fix issue：处理逻辑不对，已重写 by：rixin 2021/07/12
 */
export const evaluate = function (text) {
  const t = text || ''
  if (t === '') return
  // 先处理大括号，拿到大括号内的文本
  const regBig = /\{.*?}/g
  const b = t.replace(regBig, word => {
    // 先去掉大括号，再取斜杠前面的内容
    return word.replace(/\{|}/g, '').split('/')[0]
  })
  // 再处理中括号，拿到中括号内的文本
  const regMedium = /(\[.*?])/g
  const m = b.replace(regMedium, word => {
    return word.replace(/\[|]/g, '').split('/')[0]
  })
  // 最后去掉奇怪的分隔符，并给每行进行换行
  return m.replace(/\\/g, '/').replace(/’/g, "'").replace(/[“”]/g, '"').replace(/[#\r]/g, '').replace(/\n/g, '<br />')
}

export const randomList = list => {
  const data = _.cloneDeep(list)
  let i = data.length
  while (i) {
    const j = Math.floor(Math.random() * i--)
    ;[data[j], data[i]] = [data[i], data[j]]
  }
  return data
}

export function getCacheSize(type) {
  let obj = ''
  if (type === 'localStorage') {
    if (!window.localStorage) {
      console.log('浏览器不支持localStorage')
    } else {
      obj = window.localStorage
    }
  } else if (type === 'sessionStorage') {
    if (!window.sessionStorage) {
      console.log('浏览器不支持sessionStorage')
    } else {
      obj = window.sessionStorage
    }
  }
  if (obj !== '') {
    let size = 0
    for (const item in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(item)) {
        size += obj.getItem(item).length
      }
    }
    console.log('当前已用存储：' + (size / 1024).toFixed(2) + 'KB')
  }
}

export const setDefaultStudent = (list = []) => {
  if (!Array.isArray(list)) return []
  if (list.length < 2) {
    const classData = store.getters.classData
    const userInfo = store.getters.userInfo
    const students = DefaultStudent.map(el => {
      el = {
        ...el,
        gradeId: classData.gradeId, // 年级id
        clazzId: classData.id, // 班级id
        className: classData.name, // 班级名称
        actStatus: 0, // 用户状态 0=正常 1=禁用
        schoolId: userInfo.schoolId, // 学校id
        schoolName: userInfo.schoolName, // 学校名称
        provinceId: userInfo.provinceId, // 省id
        cityId: userInfo.cityId // 市id
      }
      return el
    })
    return [...list, ...students]
  } else {
    return [...list]
  }
}

// file 文件对象转AudioBuffer
export function fileToBuffer(file) {
  return new Promise(res => {
    const reader = new FileReader()
    reader.onload = () => {
      res(reader.result)
    }
    reader.readAsArrayBuffer(file)
  })
}

export const getRateValue = (score, totalScore = 100) => {
  let rate
  const scoreRate = (Number(score) / Number(totalScore)) * 100
  if (scoreRate > 80) {
    rate = 5
  } else if (scoreRate >= 60) {
    rate = 4
  } else if (scoreRate >= 40) {
    rate = 3
  } else if (scoreRate >= 20) {
    rate = 2
  } else {
    rate = 1
  }
  return rate
}

export const getWordTranslate = (translate, paraphrase) => {
  let result = ''
  if (translate && isJSON(translate) && JSON.parse(translate).length > 0) {
    translate = JSON.parse(translate)
    for (let j = 0, len = translate.length; j < len; j += 1) {
      const pos = partsOfSpeech(translate[j].pos)
      result += `${pos}${translate[j].translate}\n`
    }
  } else {
    result = paraphrase || ''
  }
  return result
}

// 获取单词的翻译
export const getWordTranslateV2 = function (word) {
  return word.textBookParaphrase || word.standardParaphrase || getWordTranslate(word.translate) || word.paraphrase
}

export const getMaterialTypeTag = item => {
  const { materialType, teachType, type } = item
  if (materialType === 'WORD' || materialType === 'WORD_PAPER_GROUP') {
    return wordModeTypeMap[teachType]
  }
  if (materialType === 'REPEAT_AFTER') {
    if (type === 'dialogue') {
      return articleDialogueModeTypeMap[teachType]
    }
    if (type === 'passage') {
      return articlePassageModeTypeMap[teachType]
    }
  }
  if (materialType === 'READING') {
    if (type === 'DIALOGUE') {
      return articleDialogueModeTypeMap[teachType]
    }
    if (type === 'CHAPTER') {
      return articlePassageModeTypeMap[teachType]
    }
    // if (type === 'POETRY') {
    //   return articlePassageModeTypeMap[teachType]
    // }
  }
  if (materialType === 'SENTENCE') {
    return sentenceModeTypeMap[teachType].text
  }
}

/**
 * 填充0
 * @param num 数字
 * @param targetLength 填充后数字的长度
 * @returns {string}
 */
export function fillZero(num, targetLength) {
  return num.toString().padStart(targetLength, '0')
}

// 时间转化：秒转分秒
export const formatSecond = second => {
  const minute = Math.floor(second / 60)
  const newSecond = second % 60
  return {
    min: minute,
    sec: newSecond
  }
}

export const score2Grade = scoreRate => {
  if (!scoreRate && scoreRate !== 0) {
    return ''
  }
  let grade = ''
  if (scoreRate >= 85) {
    grade = 'A'
  } else if (scoreRate >= 70) {
    grade = 'B'
  } else if (scoreRate >= 50) {
    grade = 'C'
  } else {
    grade = 'D'
  }
  return grade
}

export const Grade2ImgSrc = grade => {
  const Grade2ImgSrcMap = {
    A: require('@/assets/ggt-scoreImg/score-a.png'),
    B: require('@/assets/ggt-scoreImg/score-b.png'),
    C: require('@/assets/ggt-scoreImg/score-c.png'),
    D: require('@/assets/ggt-scoreImg/score-d.png')
  }
  if (typeof grade === 'number' && grade <= 100 && grade >= 0) {
    grade = score2Grade(grade)
  } else if (typeof grade !== 'string' || !Object.keys(Grade2ImgSrcMap).includes(grade)) {
    return ''
  } else {
    grade = grade.toUpperCase()
  }
  return Grade2ImgSrcMap[grade]
}

export const fetchGradColor = scoreRate => {
  scoreRate = Number(scoreRate)
  if (store.getters.userInfo?.thirdPartyType === 7) {
    // cd用红色
    if (scoreRate < 70) {
      return 'col-FF3C30'
    } else if (scoreRate < 85) {
      return 'col-FFA516'
    } else {
      return 'col-1DC060'
    }
  } else {
    if (scoreRate < 65) {
      return 'col-FF3C30'
    } else if (scoreRate < 85) {
      return 'col-FFA516'
    } else {
      return 'col-1DC060'
    }
  }
}

export const getScoreClassName = (score, totalScore = 100) => {
  if (!totalScore) return 'col-FF3C30'
  const rate = (Number(score) / Number(totalScore)) * 100
  let className = ''
  if (rate >= 0 && rate < 60) {
    className = 'col-FF3C30'
  } else if (rate >= 60 && rate < 85) {
    className = 'col-FFA516'
  } else if (rate >= 85 && rate <= 100) {
    className = 'col-1DC060'
  }
  return className
}

export const AudioErrorTip = code => {
  return (
    {
      1: '取回过程被用户中止',
      2: '当下载时发生错误',
      3: '当解码时发生错误',
      4: '暂无音频资源/音频资源错误'
    }[code] || '未知错误'
  )
}

/**
 * 生成26位大写字母
 * @returns {string[]}
 */
export function generateCapitalLetter() {
  let i = 64
  return new Array(26).fill(0).map(() => {
    ++i
    return String.fromCharCode(i)
  })
}

export const capitalLetters = generateCapitalLetter()

/**
 * 输出当前调用堆栈
 */
export function printCallStack(args, message = '当前调用堆栈：') {
  const stack = new Error().stack || '无堆栈信息'
  console.log(`[${message}]`, args)
  console.log(stack)
}

/**
 * 获取音频时长（秒）
 * @param src {string} 音频链接
 * @return {Promise<number>}
 */
export const getAudioDuration = src => {
  return new Promise((resolve, reject) => {
    const audio = new Audio()

    audio.onloadedmetadata = function () {
      const duration = audio.duration
      resolve(duration)
    }

    audio.onerror = function (error) {
      console.error('音频加载错误', error)
      resolve(0)
    }

    audio.src = src
  })
}

/**
 * 二进制转base64
 * @param buffer
 * @return {string} 不带base64头的base64格式数据
 */
export const arrayBufferToBase64 = buffer => {
  const bytes = new Uint8Array(buffer)
  const chunkSize = 0x8000
  let binary = ''
  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize)
    binary += String.fromCharCode.apply(null, Array.from(chunk))
  }
  return btoa(binary)
}

/**
 * 将 AudioBuffer 转换为 WAV 格式的 ArrayBuffer
 * @param {AudioBuffer} audioBuffer - 音频缓冲区对象
 * @returns {ArrayBuffer} WAV 格式的二进制数据
 */
export const audioBufferToWav = audioBuffer => {
  const length = audioBuffer.length
  const numberOfChannels = audioBuffer.numberOfChannels
  const sampleRate = audioBuffer.sampleRate
  const arrayBuffer = new ArrayBuffer(44 + length * numberOfChannels * 2)
  const view = new DataView(arrayBuffer)

  // 辅助函数：将字符串写入 DataView
  const writeString = (offset, string) => {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i))
    }
  }

  // WAV 文件头
  writeString(0, 'RIFF') // RIFF 标识符
  view.setUint32(4, 36 + length * numberOfChannels * 2, true) // RIFF 块长度
  writeString(8, 'WAVE') // WAVE 文件标志
  writeString(12, 'fmt ') // 波形格式标志
  view.setUint32(16, 16, true) // 格式块长度
  view.setUint16(20, 1, true) // 音频格式（PCM）
  view.setUint16(22, numberOfChannels, true) // 声道数
  view.setUint32(24, sampleRate, true) // 采样率
  view.setUint32(28, sampleRate * numberOfChannels * 2, true) // 字节率
  view.setUint16(32, numberOfChannels * 2, true) // 块对齐
  view.setUint16(34, 16, true) // 每样本位数
  writeString(36, 'data') // 数据块标识符
  view.setUint32(40, length * numberOfChannels * 2, true) // 数据块长度

  // 写入 PCM 采样数据
  const offset = 44
  for (let channel = 0; channel < numberOfChannels; channel++) {
    const channelData = audioBuffer.getChannelData(channel)
    for (let i = 0; i < length; i++) {
      const sample = Math.max(-1, Math.min(1, channelData[i])) // 限制在 -1 到 1 之间
      view.setInt16(offset + (i * numberOfChannels + channel) * 2, sample * 0x7fff, true)
    }
  }

  return arrayBuffer
}

/**
 * 将音频文件（OGG、MP3、WAV等）转换为 WAV 格式
 * 支持多种输入格式：URL、File 对象、ArrayBuffer
 * @param {string|File|ArrayBuffer} input - 音频输入，可以是：
 *   - 字符串：音频文件的 URL
 *   - File 对象：音频文件对象
 *   - ArrayBuffer：音频文件的二进制数据
 * @param {Object} options - 可选配置项
 * @param {boolean} options.returnBlob - 是否返回 Blob 对象，默认 false（返回 ArrayBuffer）
 * @param {string} options.blobType - Blob 的 MIME 类型，默认 'audio/wav'
 * @returns {Promise<ArrayBuffer|Blob>} WAV 格式的音频数据
 * @example
 * // 从 URL 转换
 * const wavBuffer = await convertAudioToWav('https://example.com/audio.ogg')
 *
 * // 从 File 对象转换
 * const file = document.querySelector('input[type="file"]').files[0]
 * const wavBlob = await convertAudioToWav(file, { returnBlob: true })
 *
 * // 从 ArrayBuffer 转换
 * const arrayBuffer = await fileToBuffer(file)
 * const wavBuffer = await convertAudioToWav(arrayBuffer)
 */
export const convertAudioToWav = async (input, options = {}) => {
  const { returnBlob = false, blobType = 'audio/wav' } = options
  let arrayBuffer

  try {
    // 根据输入类型获取 ArrayBuffer
    if (typeof input === 'string') {
      // 输入是 URL 字符串
      const response = await fetch(input)
      if (!response.ok) {
        throw new Error(`获取音频文件失败: ${response.status} ${response.statusText}`)
      }
      arrayBuffer = await response.arrayBuffer()
    } else if (input instanceof File) {
      // 输入是 File 对象
      arrayBuffer = await fileToBuffer(input)
    } else if (input instanceof ArrayBuffer) {
      // 输入已经是 ArrayBuffer
      arrayBuffer = input
    } else {
      throw new Error('不支持的输入类型，请输入 URL 字符串、File 对象或 ArrayBuffer')
    }

    // 创建 AudioContext 并解码音频数据
    const audioContext = new (window.AudioContext || window.webkitAudioContext)()
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer)

    // 转换为 WAV 格式
    const wavArrayBuffer = audioBufferToWav(audioBuffer)

    // 根据选项返回 ArrayBuffer 或 Blob
    if (returnBlob) {
      return new Blob([wavArrayBuffer], { type: blobType })
    }
    return wavArrayBuffer
  } catch (error) {
    console.error('音频转换失败:', error)
    throw new Error(`音频转换失败: ${error.message}`)
  }
}

/**
 * 格式化文件大小
 * @param size
 * @return {string}
 */
export const formatFileSize = size => {
  if (typeof size !== 'number' || isNaN(size)) return ''
  console.log('size', size)
  const unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']
  const index = Math.floor(Math.log(size) / Math.log(1024))
  let formatSize = size / Math.pow(1024, index)
  formatSize = formatSize.toFixed(1)
  return `${Number(formatSize)}${unitArr[index]}`
}

/**
 * 检查字符串是否以大写字母加点号开始
 * @param text
 * @returns {boolean}
 */
export const startsWithLetterPunctuation = text => {
  const regex = /^[A-Z][.]/
  return regex.test(text.trim())
}

/**
 * 获取答案info信息
 * 调用方式
 * getAnswerInfo(data?.info, data?.infoUrl)
 * @param info
 * @param infoUrl
 */
export const getAnswerInfo = async (info, infoUrl) => {
  if (info) {
    const res = info instanceof Object
    if (res) {
      return info
    } else {
      return JSON.parse(info)
    }
  }

  if (infoUrl) {
    if (infoUrl.indexOf('http://') === 0) {
      infoUrl = infoUrl.replace('http://', 'https://')
    }
    return await service.readFile(infoUrl)
  }
}

/**
 * 判断字符串中是否包含中文字符
 * @param {string} text - 待检测的字符串
 * @returns {boolean} 包含返回true，不包含返回false
 */
export const hasChineseChar = text => {
  // 核心正则：匹配Unicode范围为\u4e00-\u9fa5的中文字符
  const chineseReg = /[\u4e00-\u9fa5]/
  // test方法检测字符串是否匹配正则，返回布尔值
  return chineseReg.test(text)
}
